<template>
  <div>
    <template v-if="condition">
      <slot name="truthy" />
    </template>
    <template v-else>
      <slot name="falsy" />
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  props: {
    condition: {
      type: Boolean,
      required: true
    }
  }
});
</script>
